/**
 * Language codes supported by the Eqqo translation provider for enterprise pages.
 * Sourced from the eqqo-react README — includes 33 source languages plus 7 target variants.
 */
export const EQQO_SUPPORTED_LANGUAGES = [
  "ar",
  "bg",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fi",
  "fr",
  "he",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "lt",
  "lv",
  "nb",
  "nl",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sv",
  "th",
  "tr",
  "uk",
  "vi",
  "zh",
  "en-gb",
  "en-us",
  "es-419",
  "pt-br",
  "pt-pt",
  "zh-hans",
  "zh-hant",
];
